import { render, staticRenderFns } from "./SampleOrderForm.vue?vue&type=template&id=39ac31a3&scoped=true"
import script from "./SampleOrderForm.vue?vue&type=script&lang=ts"
export * from "./SampleOrderForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ac31a3",
  null
  
)

export default component.exports